<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form ref="model" :model="model" :rules="rules" label-width="160px">
        <el-form-item label="学生电话：">
          <span class="input-width" v-text="model.phone"></span>
        </el-form-item>
        <el-form-item :label="currentBalanceTypeLabel + '：'">
          <span class="input-width cs-balance-amount">${{model.currentBalance | toFixedString}}</span>
        </el-form-item>
        <el-form-item label="操作类型：" prop="operationType">
          <el-radio-group v-model="model.operationType" class="operation-type-group">
            <el-radio :label="true">
              <i class="el-icon-plus" style="margin-right: 5px;"></i>增加余额
            </el-radio>
            <el-radio :label="false">
              <i class="el-icon-minus" style="margin-right: 5px;"></i>减少余额
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="调整金额：" prop="amount">
          <el-input-number 
            size="small"
            v-model="model.amount" 
            :min="0" 
            :precision="2" 
            :max="99999"
            controls-position="right"
            class="input-width"
            placeholder="请输入调整金额"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="原因说明：" prop="comment">
          <el-input 
            v-model="model.comment" 
            type="textarea" 
            :rows="3"
            class="input-width"
            placeholder="请填写原因"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <div class="preview-result">
            <i class="el-icon-success" style="color: #67C23A; margin-right: 5px;"></i>
            <span>调整后余额为 <strong class="preview-amount">${{previewBalance | toFixedString}}</strong></span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="14" class="footer-left">
          <span v-if="!showError"></span>
          <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
        </el-col>
        <el-col class="footer-right" :span="10" style="text-align: right;">
          <el-button @click="triggerClose">取消</el-button>
          <el-button :disabled="submitBtnDisable" @click="saveChanges" type="primary">确认修改</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
body .popup-content-area-small {
  min-height: 300px;
  padding: 30px 50px;
}

.el-form-item {
  span {
    height: 40px;
    line-height: 40px;
  }
}

.operation-type-group {
  width: 100%;
  
  .el-radio {
    margin-right: 30px;
    
    i {
      font-size: 16px;
    }
  }
}

.cs-balance-amount {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
}

.preview-result {
  padding: 10px;
  background-color: #f0f9ff;
  border-radius: 4px;
  border: 1px solid #b3d8ff;
  
  .preview-amount {
    font-size: 18px;
    font-weight: bold;
    color: #409EFF;
  }
}

.input-width {
  width: 100%;
  max-width: 400px;
}

.footer-right {
  button {
    margin-left: 10px;
  }
}
</style>

<script>
import { saveStudentBalance } from "../../service/student.service.js";

export default {
  props: {
    dataIn: {
      type: Object,
      required: true
    }
  },
  data() {
    let validateAmount = (rule, value, callback) => {
      if (!value && value !== 0) {
        callback(new Error("请输入调整金额"));
      } else if (value <= 0) {
        callback(new Error("调整金额必须大于0"));
      } else {
        callback();
      }
    };

    let validateComment = (rule, value, callback) => {
      if (!value || value.trim() === "") {
        callback(new Error("原因说明不能为空"));
      } else {
        callback();
      }
    };

    return {
      submitBtnDisable: false,
      submitBtnClass: "primary",
      submitBtnStatus: {
        status: true,
        stopTime: null,
        resetStatus: function() {
          let self = this;
          clearTimeout(self.stopTime);
          self.stopTime = setTimeout(() => {
            self.status = true;
          }, 1500);
        }
      },
      showError: false,
      errorMessage: "",
      model: this.initModel(),
      rules: {
        amount: [
          {
            required: true,
            validator: validateAmount,
            trigger: ["blur", "change"]
          }
        ],
        comment: [
          {
            required: true,
            validator: validateComment,
            trigger: ["blur", "change"]
          }
        ],
        operationType: [
          {
            required: true,
            message: "请选择操作类型",
            trigger: ["change"]
          }
        ]
      }
    };
  },
  computed: {
    currentBalanceTypeLabel() {
      const typeMap = {
        1: "当前余额（旧）",
        2: "当前余额（新）",
        3: "当前余额（赠送）"
      };
      return typeMap[this.model.balanceType] || "当前余额";
    },
    balanceTypeLabel() {
      const typeMap = {
        1: "旧余额",
        2: "新余额",
        3: "赠送余额"
      };
      return typeMap[this.model.balanceType] || "余额";
    },
    previewBalance() {
      if (!this.model.amount || this.model.amount <= 0) {
        return this.model.currentBalance;
      }
      
      if (this.model.operationType === true) {
        // 增加余额
        return parseFloat((this.model.currentBalance + this.model.amount).toFixed(2));
      } else {
        // 减少余额
        const result = this.model.currentBalance - this.model.amount;
        return parseFloat((result >= 0 ? result : 0).toFixed(2));
      }
    }
  },
  created() {
    this.loadData();
  },
  updated() {
    this.checkAllInputs();
  },
  methods: {
    initModel() {
      let newModel = {
        studentId: 0,
        phone: "",
        currentBalance: 0,
        balanceType: 1, // 1=旧余额, 2=新余额, 3=赠送余额
        operationType: true, // true=增加, false=减少
        amount: null,
        comment: ""
      };

      return newModel;
    },
    checkAllInputs() {
      let isValid = true;

      let $ref = this.$refs["model"];
      if (!!$ref) {
        $ref.validate(valid => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }

      // if (isValid && this.model.amount > 0 && this.model.comment && this.model.comment.trim() !== "") {
      //   this.submitBtnClass = "primary";
      //   this.submitBtnDisable = false;
      // } else {
      //   this.submitBtnClass = "info";
      //   this.submitBtnDisable = true;
      // }

      return isValid;
    },
    loadData() {
      if (!this.dataIn) return;

      this.model = this.initModel();
      this.model.studentId = this.dataIn.studentId || 0;
      this.model.phone = this.dataIn.phone || "";
      this.model.currentBalance = this.dataIn.currentBalance || 0;
      this.model.balanceType = this.dataIn.balanceType || 1;
    },
    reset() {
      this.loadData();
      if (this.$refs["model"]) {
        this.$refs["model"].resetFields();
      }
      this.showError = false;
      this.errorMessage = "";
    },
    async saveChanges() {
      if (!this.submitBtnStatus.status) {
        return;
      }

      this.submitBtnStatus.status = false;

      let isValid = this.checkAllInputs();
      if (!isValid) {
        this.$message.warning("请检查界面验证错误，输入必填项!");
        this.submitBtnStatus.resetStatus();
        return;
      }

      // 验证减少余额时不能超过当前余额
      if (this.model.operationType === false && this.model.amount > this.model.currentBalance) {
        this.$message.error("减少金额不能超过当前余额");
        this.submitBtnStatus.resetStatus();
        return;
      }

      this.errorMessage = "";
      this.showError = false;

      const confirmMessage = `您确定要${this.model.operationType ? "增加" : "减少"}${this.balanceTypeLabel} $${this.model.amount.toFixed(2)} 吗？\n原因：${this.model.comment}`;
      
      try {
        await this.$confirm(confirmMessage, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });

        this.submitBtnDisable = true;

        const result = await saveStudentBalance(
          this.model.studentId,
          this.model.amount,
          this.model.balanceType,
          this.model.operationType,
          this.model.comment
        );

        if (!result) {
          this.errorMessage = "未正确连接到服务器";
          this.showError = true;
        } else if (!result.success) {
          this.errorMessage = result.message || "保存失败";
          this.showError = true;
        } else {
          this.$message({
            message: "余额修改成功",
            type: "success"
          });
          this.triggerSaveSuccess({
            balanceType: this.model.balanceType,
            newBalance: this.previewBalance
          });
          this.triggerClose();
        }

        this.submitBtnDisable = false;
      } catch (error) {
        // 用户取消操作
        if (error !== "cancel") {
          this.errorMessage = "操作失败";
          this.showError = true;
        }
      }

      this.submitBtnStatus.resetStatus();
    },
    triggerSaveSuccess(dataOut) {
      this.$emit("saveSuccess", dataOut);
    },
    triggerClose() {
      this.$emit("closeDialog");
    }
  },
  watch: {
    dataIn: {
      handler() {
        this.loadData();
      },
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/studentBalanceEditor.vue